// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"0437fba5","453":"70c73f82"}[chunkId] + ".chunk.js";
};